module.exports = __webpack_public_path__ + "static/media/captions_Heidelberg.ca54fd05.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Heidelberg.vtt
// module id = 115
// module chunks = 0